/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PurchaseReturnProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const purchaseReturnProcessFetchPurchaseReturnProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const purchaseReturnProcessFetchPurchaseReturnProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PurchaseReturnProcessTypes.PURCHASE_RETURN_PROCESS_FETCH_PURCHASE_RETURN_PROCESS_LOADING]: purchaseReturnProcessFetchPurchaseReturnProcessLoading,
  [PurchaseReturnProcessTypes.PURCHASE_RETURN_PROCESS_FETCH_PURCHASE_RETURN_PROCESS_SUCCESS]: purchaseReturnProcessFetchPurchaseReturnProcessSuccess
});
